import { ProductType } from "@/analytics";

export const cleanUndefined = (obj) =>
  Object.fromEntries(Object.entries(obj).filter(([_, v]) => v !== undefined));

export const paymentTypeMapper = {
  FullPayment: "online_payment",
  CarPaymentTypeFullPayment: "online_payment",
  OnDelivery: "pay_at_pickup",
  CarPaymentTypeOnDelivery: "pay_at_pickup",
};

export const priceFormat = (price) => {
  return Math.round(price * Math.pow(10, 0)) / Math.pow(10, 0);
};

export const buildCarEcommerceObject = ({
  carItem,
  price,
  itemIndex,
  pickUpLocation,
  dropOffLocation,
  pickUpDateTime,
  dropOffDateTime,
  itemListId,
  itemListName,
  currency,
  paymentMethod,
  selectedCoupon,
  isDomestic = null,
}) => {
  return cleanUndefined({
    item_id: [carItem?.Brand || "", carItem?.Model || ""].join(" "),
    item_name: ProductType.CAR,
    cross_product_promotion: null,
    affiliation: "turna.com",
    currency: currency?.toUpperCase(),
    item_brand: carItem?.Company?.Name,
    index: itemIndex,
    coupon:
      price?.UsedCampaign?.CampaignDetails?.CampaignCode || selectedCoupon,
    discount: priceFormat(price?.Discount || carItem?.Price?.Discount || 0),
    start_date: pickUpDateTime ? pickUpDateTime + ".000Z" : null,
    end_date: dropOffDateTime ? dropOffDateTime + ".000Z" : null,
    drop_off_location_name: dropOffLocation?.Name,
    drop_off_city_name: dropOffLocation?.City,
    pick_up_location_name: pickUpLocation?.Name,
    pick_up_city_name: pickUpLocation?.City,
    item_list_id: itemListId,
    item_list_name: itemListName,
    item_category: ProductType.CAR,
    item_category2:
      isDomestic !== null ? (isDomestic ? "domestic" : "international") : null,
    item_category3: carItem?.Brand,
    item_category4: carItem?.Model,
    item_category5: String(
      carItem?.VehicleClass || carItem?.Class || "",
    ).replaceAll("VehicleClass", ""),
    item_variant: null,
    item_fuel: String(carItem?.FuelType || "").replaceAll("FuelType", ""),
    item_transmission: String(carItem?.Transmission || "").replaceAll(
      "Transmission",
      "",
    ),
    mileage_value: carItem?.MileageLimit,
    mileage_unit: "km",
    payment_method: paymentTypeMapper[paymentMethod] || paymentMethod,
    rental_days: carItem?.TotalRentalDays,
    price: priceFormat(
      price?.totalPrice ||
        price?.TotalFareWithoutDiscount ||
        price?.TotalFare ||
        price?.DailyPrice ||
        carItem?.DailyPrice ||
        0,
    ),
    daily_price: priceFormat(price?.DailyPrice || carItem?.DailyPrice || 0),
    quantity: 1,
  });
};
